import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initGridOfCustomStaffCards() {
  Alpine.data(
    'gridOfCustomStaffCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.sw-CustomStaffCards');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        const onlyGrid = domEl.classList.contains('only-grid');
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          slidesPerView: 4,
          spaceBetween: 20,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 4,
              autoplay: onlyGrid
                ? {
                  delay: 2500,
                  disableOnInteraction: true,
                  pauseOnMouseEnter: true,
                } : false,
            },
          },
        });
      },
    }),
  );
}
